import { BaseTableEditorStore } from '@/tableDefinitionEditor/baseTableEditorStore';
import { ColumnDefinition } from '@/tableDefinitionEditor/tableDefinition.types';
import { sqItemTableDefinitionStore } from '@/core/core.stores';

export class ItemTableEditorStore extends BaseTableEditorStore {
  static readonly storeName = 'sqItemTableEditorStore';

  get columnToEdit(): ColumnDefinition | undefined {
    return this.getColumnToEdit({
      columnToEditId: this.columnToEditId,
      existingColumns: sqItemTableDefinitionStore.columns,
    });
  }

  override handlers = {
    ITEM_SET_TABLE_ID: this.setTableId,
    ITEM_RESET_TABLE_EDITOR_STORE: this.reset,
    ITEM_SET_SHOW_CONFIGURE_SEARCH: this.setShowConfigureSearch,
    ITEM_SET_ENABLE_TREE_CREATION: this.setEnableTreeCreation,
    ITEM_SET_COLUMN_TO_EDIT_ID: this.setColumnToEditId,
    ITEM_SET_SHOW_COLUMN_PROPERTIES: this.setShowColumnProperties,
    ITEM_SET_SELECTED_COLUMN_OPTION: this.setSelectedColumnOption,
    ITEM_SET_SHORTCUT_SOURCE_COLUMN: this.setShortcutSourceColumn,
    ITEM_SET_INCLUDE_HIERARCHY: this.setIncludeHierarchy,
    ITEM_SET_CONTROL_PANE: this.setControlPane,
  };
}
